/* eslint-disable @typescript-eslint/no-require-imports */

/** Parcel-bundled image URLs (use these instead of /Images/... from ASP.NET). */

export const img123Final2: string = require("url:../assets/img/123Final2.png");
export const imgImagesFinal: string = require("url:../assets/img/ImagesFinal.png");
export const imgVariableDataFinal2: string = require(
  "url:../assets/img/VariableDataFinal2.png",
);
export const imgQrCodeNuevo: string = require("url:../assets/img/qr-codeNuevo.png");
export const imgTxtPng: string = require("url:../assets/img/TxtPNG.png");
export const imgBarCodeFinal2: string = require(
  "url:../assets/img/barCodeFinal2.png",
);
export const imgDinLabelLogoLetras: string = require(
  "url:../assets/img/DINLabelLogoLetras.png",
);
export const imgDinLabelLaptop: string = require(
  "url:../assets/img/DINLabelLaptop.png",
);
export const imgMailIcon: string = require("url:../assets/img/mailicon.png");
export const imgTutoriales: string = require("url:../assets/img/tutoriales.png");
export const imgEtiquetaConMarcaDeAgua: string = require(
  "url:../assets/img/EtiquetaConMarcaDeAgua.png",
);
export const imgEtiquetaSinMarcaDeAgua: string = require(
  "url:../assets/img/EtiquetaSinMarcaDeAgua.png",
);
export const imgEtiquetaRollo1: string = require(
  "url:../assets/img/etiquetaRollo1.png",
);
export const imgPlanilla1: string = require("url:../assets/img/planilla1.png");
export const img3AlPaso: string = require("url:../assets/img/3alPaso.png");
export const imgFiguras1: string = require("url:../assets/img/figuras1.png");
export const imgPrinter1: string = require("url:../assets/img/printer1.png");
export const imgLogoNoText128: string = require(
  "url:../assets/img/logoNoText128x128.png",
);
export const imgEtiprint: string = require("url:../assets/img/etiprint.png");
export const imgLogoCt: string = require("url:../assets/img/logo-ct.png");
